interface IError{
    message: string,
    name: string,
    stack: string,
}

export const instanceOfIError = (object: any) : object is IError => {
    return 'message' in object &&
            'name' in object &&
            'stack' in object
}

export default IError